export default __webpack_public_path__ + "static/media/vault.d22941dd.svg";